import { REFERRAL_QR_PNG } from '../config';

type DownloadReferralQrPngParams = {
  qrCanvas: HTMLCanvasElement;
  link: string;
};

const canvasToPngBlob = (canvas: HTMLCanvasElement) =>
  new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, 'image/png');
  });

export const downloadReferralQrPng = async ({
  qrCanvas,
  link,
}: DownloadReferralQrPngParams) => {
  const { width, height, padding, qrSize, textCenterY, font, fileName } =
    REFERRAL_QR_PNG;

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('2D canvas context is unavailable');
  }

  // Printed and scanned, so black on white whatever the UI theme.
  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, width, height);
  context.drawImage(qrCanvas, padding, padding, qrSize, qrSize);

  context.fillStyle = '#000000';
  context.font = font;
  context.textAlign = 'center';
  context.textBaseline = 'middle';
  context.fillText(link, width / 2, textCenterY, width - padding * 2);

  const blob = await canvasToPngBlob(canvas);

  if (!blob) {
    throw new Error('The QR code image could not be encoded');
  }

  const url = URL.createObjectURL(blob);

  // Firefox ignores click() on a detached anchor, and revoking synchronously
  // races the start of the download in several engines.
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  setTimeout(() => URL.revokeObjectURL(url));
};
